import React, { useCallback } from 'react';
import t from '~t';

import { Confirm } from '~co/overlay/dialog';
import { Button, Icon, Preloader } from '~ui';

export default function CollectionsSelectMode({
  selectMode: { enabled, ids, working },
  actions,
}) {
  const onSelectAll = useCallback(() => actions.selectAll(), [actions]);
  const onCancel = useCallback(() => actions.unselectAll(), [actions]);

  const onMergeSelected = useCallback(async () => {
    if (
      await Confirm(
        `${t.s('areYouSure')}\n${t.s('merge')} ${ids.length} ${t.s(
          'collectionsCount',
        )}.\n${t.s('mergeCollectionsConfirm')}`,
      )
    )
      actions.mergeSelected();
  }, [actions, ids]);

  const onRemoveSelected = useCallback(async () => {
    if (
      await Confirm(
        `${t.s('areYouSure')}\n${t.s('remove')} ${ids.length} ${t.s(
          'collectionsCount',
        )}`,
      )
    )
      actions.removeSelected();
  }, [actions, ids]);

  if (!enabled) return null;

  return (
    <div className='absolute left-[7px] right-[7px] top-px z-[3] overflow-hidden rounded-lg shadow-[0_0_0_var(--shadow-height)_var(--shadow-color),0_3px_15px_rgba(0,0,0,.1)]'>
      <div className='bg-background'>
        {working ? (
          <div className='flex items-center px-[var(--padding-medium)] py-[var(--padding-small)]'>
            <div className='flex-1 truncate font-semibold'>
              {t.s(working)} {ids.length} {t.s('collectionsCount')}...
            </div>
            <Preloader />
          </div>
        ) : (
          <>
            <div className='flex items-center px-[var(--padding-medium)] py-[var(--padding-small)]'>
              <div className='flex-1 truncate font-semibold'>
                {ids.length} {t.s('collectionsCount')}
              </div>

              <Button variant='ghost' size='sm' onClick={onSelectAll}>
                {t.s('all')}
              </Button>
              &nbsp; &nbsp;
              <Button variant='ghost' size='sm' onClick={onCancel}>
                {t.s('cancel')}
              </Button>
            </div>

            <div className='-mt-2.5 flex items-center px-[var(--padding-mini)] py-[var(--padding-small)]'>
              {ids.length > 1 ? (
                <Button variant='link' onClick={onMergeSelected}>
                  <Icon name='duplicates' />

                  <span className='hide-on-small-body'>
                    {t.s('merge')}
                  </span>
                </Button>
              ) : null}

              <Button variant='link' onClick={onRemoveSelected}>
                <Icon name='trash' />

                <span className='hide-on-small-body'>
                  {t.s('remove')}
                </span>
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
